import { Property } from "./property";

// User related types (updated to match actual API response)
export interface User {
    id: number;
    externalId?: string;
    email: string;
    firstName?: string;
    lastName?: string;
    fullName?: string;
    type: UserType;
    phone?: string;
    phoneNumber?: string; // API uses phoneNumber
    propertyId?: number;
    property?: Property;
    currentLeaseId?: number;
    profilePictureUrl?: string;
    photoUrl?: string; // API uses photoUrl for profile photo
    createdAt: string;
    updatedAt: string;
    
    // Additional fields from API response
    unitNumber?: string;
    unitNumberSpace?: string;
    spaceConfiguration?: string;
    statusType?: string;
    startDate?: string;
    endDate?: string;
    floorPlanId?: number;
    unitId?: number;
    paymentsBlocked?: boolean;
    hidden?: boolean;
    buildingName?: string | null;
    LeaseCustomer?: any; // Complex nested object
    customerType?: string;
    leaseId?: number;
    accountId?: number;
    address?: string | null;
    postalCode?: string | null;
    leaseCustomerStatus?: string;
    moveInDate?: string;
    moveOutDate?: string | null;
    lease?: any; // Complex lease object
    entrataIsActive?: boolean;
    hasFutureLease?: boolean;
    leaseIds?: number[];
    appVersion?: string;
    isAndroidDevice?: boolean;
    emailIsVerified?: boolean;
    enablePushNotificationMessages?: boolean;
    enablePushNotificationMaintenance?: boolean;
    enablePushNotificationPayments?: boolean;
    installedAppTimestamp?: string;
    lastInteractionDate?: string;
    timezone?: string | null;
    emailOptIn?: boolean;
    termsApprovedDate?: string;
    cardConnectProfileId?: string;
    preferredPaymentSource?: string;
    deletedAt?: string | null;
    roommateBio?: string;
    roommatesSharePhone?: boolean;
    roommatesShareEmail?: boolean;
    lastPaymentDate?: string;
    messagingOptOut?: string | null;
    
    // Admin-specific fields
    roles?: Array<{
      id: number;
      organizationId: number;
      name: string;
      propertyId?: number | null;
      createdAt: string;
      updatedAt: string;
      deletedAt?: string | null;
      AccountRole?: any;
      organization?: any;
    }>;
  }
  
  export enum UserType {
    RESIDENT = 1,
    GUEST = 2,
    GUARANTOR = 3,
    // Admin types (matching admin web app)
    SUPER_ADMIN = 4,
    ORG_ADMIN = 5,
    PROPERTY_ADMIN = 6,
    BILLING_ADMIN = 7,
  }